/* eslint-disable */

window.flowy = function(canvas, grab, release, snapping, rearrange, spacing_x, spacing_y) {    
    if (!grab) {
        grab = function() {};
    }
    if (!release) {
        release = function() {};
    }
    if (!snapping) {
        snapping = function() {
            return true;
        }
    }
    if (!rearrange) {
        rearrange = function() {
            return false;
        }
    }
    if (!spacing_x) {
        spacing_x = 20;
    }
    if (!spacing_y) {
        spacing_y = 80;
    }
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    }
    if (!Element.prototype.closest) {
        Element.prototype.closest = function(s) {
            var el = this;
            do {
                if (Element.prototype.matches.call(el, s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }
    var loaded = false;
    flowy.load = function() {
        if (!loaded)
            loaded = true;
        else
            return;
        var blocks = [];
        var blockstemp = [];
        var canvas_div = canvas;
        var absx = 0;
        var absy = 0;
        if (window.getComputedStyle(canvas_div).position == "absolute" || window.getComputedStyle(canvas_div).position == "fixed") {
            absx = canvas_div.getBoundingClientRect().left;
            absy = canvas_div.getBoundingClientRect().top;
        }
        var active = false;
        var paddingx = spacing_x;
        var paddingy = spacing_y;
        var offsetleft = 0;
        var rearrange = false;
        var drag, dragx, dragy, original;
        var mouse_x, mouse_y;
        var dragblock = false;
        var wasDragging = false;
        var justCompletedDrop = false; // Track if we just completed a successful drop
        var mouseDownPos = null; // Track mouse position on mousedown for click detection
        var dragThreshold = 5; // Minimum pixels to move before considering it a drag
        var prevblock = 0;
        var el = document.createElement("DIV");
        el.classList.add('indicator');
        el.classList.add('invisible');
        canvas_div.appendChild(el);
        flowy.import = function(output) {
            canvas_div.innerHTML = output.html;
            for (var a = 0; a < output.blockarr.length; a++) {
                blocks.push({
                    childwidth: parseFloat(output.blockarr[a].childwidth),
                    parent: parseFloat(output.blockarr[a].parent),
                    id: parseFloat(output.blockarr[a].id),
                    x: parseFloat(output.blockarr[a].x),
                    y: parseFloat(output.blockarr[a].y),
                    width: parseFloat(output.blockarr[a].width),
                    height: parseFloat(output.blockarr[a].height)
                })
            }
            
            // RECOVERY: Detect and handle orphaned blocks (in DOM but not in blocks array)
            var blockIds = blocks.map(b => b.id);
            var domBlocks = canvas_div.querySelectorAll('.blockid');
            var orphanedBlocks = [];
            
            domBlocks.forEach(function(blockIdInput) {
                var domBlockId = parseInt(blockIdInput.value);
                if (!blockIds.includes(domBlockId)) {
                    orphanedBlocks.push({
                        id: domBlockId,
                        element: blockIdInput.closest('.blockelem')
                    });
                }
            });
            
            if (orphanedBlocks.length > 0) {
                console.warn('[Flowy] Detected ' + orphanedBlocks.length + ' orphaned block(s) in DOM but not in blocks array:', orphanedBlocks.map(b => b.id));
                
                // Remove orphaned blocks from DOM to prevent errors
                orphanedBlocks.forEach(function(orphan) {
                    if (orphan.element) {
                        console.warn('[Flowy] Removing orphaned block from DOM:', orphan.id);
                        orphan.element.remove();
                        
                        // Also remove any associated arrows
                        var arrowEl = canvas_div.querySelector(".arrowid[value='" + orphan.id + "']");
                        if (arrowEl && arrowEl.parentNode) {
                            arrowEl.parentNode.remove();
                        }
                    }
                });
            }
            
            // Also check for blocks in array that don't have DOM elements
            var indicesToRemove = [];
            for (var i = blocks.length - 1; i >= 0; i--) {
                var domEl = canvas_div.querySelector(".blockid[value='" + blocks[i].id + "']");
                if (!domEl) {
                    console.warn('[Flowy] Block ' + blocks[i].id + ' is in array but not in DOM, removing');
                    indicesToRemove.push(i);
                }
            }
            // Remove in reverse order to avoid index shifting
            indicesToRemove.forEach(function(index) {
                blocks.splice(index, 1);
            });
            if (indicesToRemove.length > 0) {
                console.warn('[Flowy] Removed ' + indicesToRemove.length + ' ghost block(s) from array');
            }
            
            if (blocks.length > 1) {
                rearrangeMe();
                checkOffset();
            }
        }
        
        // Debug function to check workflow integrity
        flowy.debug = function() {
            var blockIds = blocks.map(b => b.id);
            var domBlocks = canvas_div.querySelectorAll('.blockid');
            var domBlockIds = Array.from(domBlocks).map(el => parseInt(el.value));
            
            console.log('[Flowy Debug] Blocks in array:', blockIds);
            console.log('[Flowy Debug] Blocks in DOM:', domBlockIds);
            
            var orphanedInDom = domBlockIds.filter(id => !blockIds.includes(id));
            var ghostInArray = blockIds.filter(id => !domBlockIds.includes(id));
            
            if (orphanedInDom.length > 0) {
                console.warn('[Flowy Debug] Orphaned blocks (in DOM but not array):', orphanedInDom);
            }
            if (ghostInArray.length > 0) {
                console.warn('[Flowy Debug] Ghost blocks (in array but not DOM):', ghostInArray);
            }
            if (orphanedInDom.length === 0 && ghostInArray.length === 0) {
                console.log('[Flowy Debug] ✅ Workflow integrity OK - all blocks synced');
            }
            
            return {
                blocksInArray: blockIds,
                blocksInDOM: domBlockIds,
                orphanedInDOM: orphanedInDom,
                ghostInArray: ghostInArray,
                isValid: orphanedInDom.length === 0 && ghostInArray.length === 0
            };
        }
        
        // Repair function to sync blocks array with DOM
        flowy.repair = function() {
            console.log('[Flowy Repair] Starting workflow repair...');
            var repaired = false;
            
            // Remove orphaned DOM elements
            var blockIds = blocks.map(b => b.id);
            var domBlocks = canvas_div.querySelectorAll('.blockid');
            
            domBlocks.forEach(function(blockIdInput) {
                var domBlockId = parseInt(blockIdInput.value);
                if (!blockIds.includes(domBlockId)) {
                    var blockEl = blockIdInput.closest('.blockelem');
                    if (blockEl) {
                        console.log('[Flowy Repair] Removing orphaned block from DOM:', domBlockId);
                        blockEl.remove();
                        repaired = true;
                    }
                    // Remove associated arrow
                    var arrowEl = canvas_div.querySelector(".arrowid[value='" + domBlockId + "']");
                    if (arrowEl && arrowEl.parentNode) {
                        arrowEl.parentNode.remove();
                    }
                }
            });
            
            // Remove ghost blocks from array (use splice to modify in place)
            var domBlockIds = Array.from(canvas_div.querySelectorAll('.blockid')).map(el => parseInt(el.value));
            var ghostBlockIndices = [];
            for (var i = blocks.length - 1; i >= 0; i--) {
                if (!domBlockIds.includes(blocks[i].id)) {
                    console.log('[Flowy Repair] Removing ghost block from array:', blocks[i].id);
                    ghostBlockIndices.push(i);
                }
            }
            // Remove in reverse order to avoid index shifting issues
            ghostBlockIndices.forEach(function(index) {
                blocks.splice(index, 1);
                repaired = true;
            });
            
            if (ghostBlockIndices.length > 0) {
                console.log('[Flowy Repair] Removed', ghostBlockIndices.length, 'ghost block(s) from array');
            }
            
            if (repaired) {
                console.log('[Flowy Repair] ✅ Repair complete');
                console.log('[Flowy Repair] Blocks now:', blocks.map(b => b.id));
                if (blocks.length > 1) {
                    rearrangeMe();
                    checkOffset();
                }
            } else {
                console.log('[Flowy Repair] No repairs needed');
            }
            
            return repaired;
        }
        
        flowy.output = function() {
            var html_ser = canvas_div.innerHTML;
            var json_data = {
                html: html_ser,
                blockarr: blocks,
                blocks: []
            };
            if (blocks.length > 0) {
                for (var i = 0; i < blocks.length; i++) {
                    json_data.blocks.push({
                        id: blocks[i].id,
                        parent: blocks[i].parent,
                        data: [],
                        attr: []
                    });
                    var blockParent = document.querySelector(".blockid[value='" + blocks[i].id + "']").parentNode;
                    blockParent.querySelectorAll("input").forEach(function(block) {
                        var json_name = block.getAttribute("name");
                        var json_value = block.value;
                        json_data.blocks[i].data.push({
                            name: json_name,
                            value: json_value
                        });
                    });
                    Array.prototype.slice.call(blockParent.attributes).forEach(function(attribute) {
                        var jsonobj = {};
                        jsonobj[attribute.name] = attribute.value;
                        json_data.blocks[i].attr.push(jsonobj);
                    });
                }
                return json_data;
            }
        }
        flowy.deleteBlocks = function() {
            blocks = [];
            canvas_div.innerHTML = "<div class='indicator invisible'></div>";
        }
        
        // Delete a single block by ID
        flowy.deleteBlock = function(blockId) {
            // Find all blocks that need to be deleted (this block and all descendants)
            var blocksToDelete = [];
            var queue = [blockId];
            
            while (queue.length > 0) {
                var currentId = queue.shift();
                blocksToDelete.push(currentId);
                
                // Find all children of this block
                blocks.forEach(function(b) {
                    if (b.parent === currentId && !blocksToDelete.includes(b.id)) {
                        queue.push(b.id);
                    }
                });
            }
            
            // Remove blocks from the array
            blocks = blocks.filter(function(b) {
                return !blocksToDelete.includes(b.id);
            });
            
            // Remove block elements and arrows from DOM
            blocksToDelete.forEach(function(id) {
                // Remove the block element
                var blockInput = document.querySelector(".blockid[value='" + id + "']");
                if (blockInput) {
                    var blockElem = blockInput.closest('.blockelem');
                    if (blockElem && blockElem.parentNode) {
                        blockElem.parentNode.removeChild(blockElem);
                    }
                }
                
                // Remove any arrows connected to this block
                var arrows = document.querySelectorAll(".arrowblock[data-parent='" + id + "'], .arrowblock[data-child='" + id + "']");
                arrows.forEach(function(arrow) {
                    if (arrow.parentNode) {
                        arrow.parentNode.removeChild(arrow);
                    }
                });
            });
            
            // Trigger rearrange to clean up any visual issues
            rearrangeMe();
            
            return blocksToDelete;
        }

        flowy.beginDrag = function(event) {
            if (window.getComputedStyle(canvas_div).position == "absolute" || window.getComputedStyle(canvas_div).position == "fixed") {
                absx = canvas_div.getBoundingClientRect().left;
                absy = canvas_div.getBoundingClientRect().top;
            }
            if (event.targetTouches) {
                mouse_x = event.changedTouches[0].clientX;
                mouse_y = event.changedTouches[0].clientY;
            } else {
                mouse_x = event.clientX;
                mouse_y = event.clientY;
            }
            if (event.which != 3 && event.target.closest(".create-flowy")) {
                original = event.target.closest(".create-flowy");
                var newNode = event.target.closest(".create-flowy").cloneNode(true);
                event.target.closest(".create-flowy").classList.add("dragnow");
                newNode.classList.add("block");
                newNode.classList.remove("create-flowy");
                if (blocks.length === 0) {
                    newNode.innerHTML += "<input type='hidden' name='blockid' class='blockid' value='" + blocks.length + "'>";
                    document.body.appendChild(newNode);
                    drag = document.querySelector(".blockid[value='" + blocks.length + "']").parentNode;
                } else {
                    newNode.innerHTML += "<input type='hidden' name='blockid' class='blockid' value='" + (Math.max.apply(Math, blocks.map(a => a.id)) + 1) + "'>";
                    document.body.appendChild(newNode);
                    drag = document.querySelector(".blockid[value='" + (parseInt(Math.max.apply(Math, blocks.map(a => a.id))) + 1) + "']").parentNode;
                }
                blockGrabbed(event.target.closest(".create-flowy"));
                if (drag && drag.classList) {
                    drag.classList.add("dragging");
                }
                active = true;
                wasDragging = true; // Mark that we initiated a drag from sidebar
                dragx = mouse_x - (event.target.closest(".create-flowy").getBoundingClientRect().left);
                dragy = mouse_y - (event.target.closest(".create-flowy").getBoundingClientRect().top);
                drag.style.left = mouse_x - dragx + "px";
                drag.style.top = mouse_y - dragy + "px";
            }
        }

        flowy.endDrag = function(event) {
            if (event.which != 3 && (active || rearrange)) {
                dragblock = false;
                blockReleased();
                const indicatorElement = document.querySelector(".indicator");
                if (indicatorElement && !indicatorElement.classList.contains("invisible")) {
                    indicatorElement.classList.add("invisible");
                }
                if (active) {
                    if (original && original.classList) {
                        original.classList.remove("dragnow");
                    }
                    if (drag && drag.classList) {
                        drag.classList.remove("dragging");
                    }
                }
                if (parseInt(drag.querySelector(".blockid").value) === 0 && rearrange) {
                    firstBlock("rearrange")    
                } else if (active && blocks.length == 0 && (drag.getBoundingClientRect().top + window.scrollY) > (canvas_div.getBoundingClientRect().top + window.scrollY) && (drag.getBoundingClientRect().left + window.scrollX) > (canvas_div.getBoundingClientRect().left + window.scrollX)) {
                    firstBlock("drop");
                } else if (active && blocks.length == 0) {
                    // Allow blocks to be placed even if no other blocks exist, but within canvas bounds
                    const canvasRect = canvas_div.getBoundingClientRect();
                    const dragRect = drag.getBoundingClientRect();
                    
                    if (dragRect.left > canvasRect.left && dragRect.right < canvasRect.right && 
                        dragRect.top > canvasRect.top && dragRect.bottom < canvasRect.bottom) {
                        // Block is within canvas bounds, allow it to be placed
                        firstBlock("drop");
                    } else {
                        removeSelection();
                    }
                } else if (active) {
                    var blocko = blocks.map(a => a.id);
                    var attached = false;
                    
                    for (var i = 0; i < blocks.length; i++) {
                        if (checkAttach(blocko[i])) {
                            active = false;
                            attached = true;
                            if (blockSnap(drag, false, document.querySelector(".blockid[value='" + blocko[i] + "']").parentNode)) {
                                justCompletedDrop = true; // Mark that we just completed a successful drop
                                snap(drag, i, blocko);
                            } else {
                                active = false;
                                removeSelection();
                            }
                            break;
                        }
                    }
                    
                    // If not attached to any block, check if it's at least in the canvas area
                    if (!attached) {
                        const canvasRect = canvas_div.getBoundingClientRect();
                        const dragRect = drag.getBoundingClientRect();
                        
                        if (dragRect.left > canvasRect.left && dragRect.right < canvasRect.right && 
                            dragRect.top > canvasRect.top && dragRect.bottom < canvasRect.bottom) {
                            // Block is within canvas bounds, treat it as a standalone block
                            active = false;
                            firstBlock("drop");
                        } else {
                            active = false;
                            removeSelection();
                        }
                    }
                } else if (rearrange) {
                    var blocko = blocks.map(a => a.id);
                    var reattached = false;
                    
                    for (var i = 0; i < blocks.length; i++) {
                        if (checkAttach(blocko[i])) {
                            active = false;
                            reattached = true;
                            if (drag && drag.classList) {
                                drag.classList.remove("dragging");
                            }
                            snap(drag, i, blocko);
                            break;
                        }
                    }
                    
                    if (!reattached) {
                        // Try to snap back to original position if possible
                        if (prevblock !== undefined && prevblock !== -1) {
                            // Try to reattach to previous parent
                            const prevParentIndex = blocko.indexOf(prevblock);
                            if (prevParentIndex !== -1 && beforeDelete(drag, blocks.filter(id => id.id == prevblock)[0])) {
                                active = false;
                                if (drag && drag.classList) {
                                    drag.classList.remove("dragging");
                                }
                                snap(drag, prevParentIndex, blocko);
                            } else {
                                // Snap back failed, remove the block
                                rearrange = false;
                                blockstemp = [];
                                active = false;
                                cleanupDragStyling();
                                removeSelection();
                            }
                        } else {
                            // It was a root block, check if it can be placed as standalone
                            const canvasRect = canvas_div.getBoundingClientRect();
                            const dragRect = drag.getBoundingClientRect();
                            
                            if (dragRect.left > canvasRect.left && dragRect.right < canvasRect.right && 
                                dragRect.top > canvasRect.top && dragRect.bottom < canvasRect.bottom) {
                                // Place as root block
                                active = false;
                                rearrange = false;
                                cleanupDragStyling();
                                firstBlock("rearrange");
                            } else {
                                rearrange = false;
                                blockstemp = [];
                                active = false;
                                cleanupDragStyling();
                                removeSelection();
                            }
                        }
                    }
                }
            }
        }
        
        function checkAttach(id) {
            if (!drag) return false;
            
            const targetBlock = blocks.filter(a => a.id == id)[0];
            if (!targetBlock) return false;
            
            const xpos = (drag.getBoundingClientRect().left + window.scrollX) + (parseInt(window.getComputedStyle(drag).width) / 2) + canvas_div.scrollLeft - canvas_div.getBoundingClientRect().left;
            const ypos = (drag.getBoundingClientRect().top + window.scrollY) + canvas_div.scrollTop - canvas_div.getBoundingClientRect().top;
            
            // Make the drop zone more forgiving by increasing the attachment area
            const attachPaddingX = paddingx + 30; // Increase horizontal tolerance
            const attachPaddingY = 40; // Add vertical tolerance below the block
            
            const inHorizontalRange = xpos >= targetBlock.x - (targetBlock.width / 2) - attachPaddingX && 
                                    xpos <= targetBlock.x + (targetBlock.width / 2) + attachPaddingX;
            
            const inVerticalRange = ypos >= targetBlock.y + (targetBlock.height / 2) && 
                                  ypos <= targetBlock.y + targetBlock.height + attachPaddingY;
            
            return inHorizontalRange && inVerticalRange;
        }
        
        function removeSelection() {
            const indicatorElement = document.querySelector(".indicator");
            if (canvas_div && indicatorElement) {
                canvas_div.appendChild(indicatorElement);
            }
            if (drag && drag.parentNode) {
                // Instead of removing the block, return it to the original position or snap back
                snapBackToOriginalPosition();
            }
        }

        function snapBackToOriginalPosition() {
            if (!drag) {
                return;
            }
            
            // If it's a new block being dragged from sidebar, remove it
            if (active && original && original.classList && original.classList.contains("dragnow")) {
                if (original && original.classList) {
                    original.classList.remove("dragnow");
                }
                if (drag && drag.parentNode) {
                    drag.parentNode.removeChild(drag);
                }
                return;
            }
            
            // If it's an existing block being rearranged, snap back to its last valid position
            if (rearrange && blockstemp.length > 0) {
                // Find the block's original data
                const blockId = parseInt(drag.querySelector(".blockid").value);
                const originalBlockData = blockstemp.find(b => b.id === blockId);
                
                if (originalBlockData && originalBlockData.parent !== undefined) {
                    // Restore the block to its original parent and position
                    blocks = blocks.concat(blockstemp);
                    blockstemp = [];
                    
                    // Position the block back where it was
                    if (originalBlockData.parent === -1) {
                        // It was a root block
                        canvas_div.appendChild(drag);
                        drag.style.left = (originalBlockData.x - (parseInt(window.getComputedStyle(drag).width) / 2) - canvas_div.getBoundingClientRect().left + window.scrollX + canvas_div.scrollLeft) + "px";
                        drag.style.top = (originalBlockData.y - (parseInt(window.getComputedStyle(drag).height) / 2) - canvas_div.getBoundingClientRect().top + window.scrollY + canvas_div.scrollTop) + "px";
                    } else {
                        // It had a parent, restore the relationship
                        const parentElement = document.querySelector(".blockid[value='" + originalBlockData.parent + "']");
                        if (parentElement && parentElement.parentNode) {
                            canvas_div.appendChild(drag);
                            // Position relative to parent
                            const parentBlock = blocks.find(b => b.id === originalBlockData.parent);
                            if (parentBlock) {
                                drag.style.left = (originalBlockData.x - (parseInt(window.getComputedStyle(drag).width) / 2) - canvas_div.getBoundingClientRect().left + window.scrollX + canvas_div.scrollLeft) + "px";
                                drag.style.top = (originalBlockData.y - (parseInt(window.getComputedStyle(drag).height) / 2) - canvas_div.getBoundingClientRect().top + window.scrollY + canvas_div.scrollTop) + "px";
                            }
                        }
                    }
                    
                    rearrangeMe();
                    checkOffset();
                    return;
                }
            }
            
            // Fallback: remove the block only if we can't restore it
            if (drag && drag.parentNode) {
                drag.parentNode.removeChild(drag);
            }
        }

        function cleanupDragStyling(resetWasDragging = false) {
            // Remove drag styling from the dragged block
            if (drag && drag.classList) {
                drag.classList.remove("dragging", "dragging-block", "being-dragged");
            }
            
            // Also clean up any other blocks that might have drag classes stuck on them
            var allBlocks = document.querySelectorAll(".block");
            allBlocks.forEach(function(block) {
                if (block.classList) {
                    block.classList.remove("dragging", "dragging-block", "being-dragged");
                }
            });
            
            // Remove canvas drag state
            var canvas = document.getElementById("canvas");
            if (canvas) {
                canvas.classList.remove("drag-active");
            }
            
            // Reset state variables
            active = false;
            dragblock = false;
            mouseDownPos = null; // Reset click detection
            if (resetWasDragging) {
                wasDragging = false;
            }
            
            // Remove drop zone indicators
            var dropZones = document.querySelectorAll(".valid-drop-zone, .invalid-drop-zone, .drop-indicator");
            dropZones.forEach(function(zone) {
                zone.classList.remove("valid-drop-zone", "invalid-drop-zone");
                if (zone.classList.contains("drop-indicator")) {
                    zone.remove();
                }
            });
        }

        function showDropZoneHints() {
            // Clean up existing indicators first
            var existingIndicators = document.querySelectorAll(".drop-indicator");
            existingIndicators.forEach(function(indicator) {
                indicator.remove();
            });
            
            // Add visual hints for valid drop zones on existing blocks
            blocks.forEach(function(block) {
                var blockElement = document.querySelector(".blockid[value='" + block.id + "']");
                if (blockElement && blockElement.parentNode) {
                    var parent = blockElement.parentNode;
                    
                    // Create drop indicator
                    var indicator = document.createElement('div');
                    indicator.className = 'drop-indicator';
                    indicator.style.left = (block.x - 10) + 'px';
                    indicator.style.top = (block.y + block.height + 20) + 'px';
                    
                    canvas_div.appendChild(indicator);
                }
            });
        }
        
        function firstBlock(type) {
            if (type == "drop") {
                blockSnap(drag, true, undefined);
                active = false;
                justCompletedDrop = true; // Mark that we just completed a successful drop
                drag.style.top = (drag.getBoundingClientRect().top + window.scrollY) - (absy + window.scrollY) + canvas_div.scrollTop + "px";
                drag.style.left = (drag.getBoundingClientRect().left + window.scrollX) - (absx + window.scrollX) + canvas_div.scrollLeft + "px";
                canvas_div.appendChild(drag);
                blocks.push({
                    parent: -1,
                    childwidth: 0,
                    id: parseInt(drag.querySelector(".blockid").value),
                    x: (drag.getBoundingClientRect().left + window.scrollX) + (parseInt(window.getComputedStyle(drag).width) / 2) + canvas_div.scrollLeft - canvas_div.getBoundingClientRect().left,
                    y: (drag.getBoundingClientRect().top + window.scrollY) + (parseInt(window.getComputedStyle(drag).height) / 2) + canvas_div.scrollTop - canvas_div.getBoundingClientRect().top,
                    width: parseInt(window.getComputedStyle(drag).width),
                    height: parseInt(window.getComputedStyle(drag).height)
                });
            } else if (type == "rearrange") {
                cleanupDragStyling();
                rearrange = false;
                for (var w = 0; w < blockstemp.length; w++) {
                    if (blockstemp[w].id != parseInt(drag.querySelector(".blockid").value)) {
                        const blockParent = document.querySelector(".blockid[value='" + blockstemp[w].id + "']").parentNode;
                        const arrowParent = document.querySelector(".arrowid[value='" + blockstemp[w].id + "']").parentNode;
                        blockParent.style.left = (blockParent.getBoundingClientRect().left + window.scrollX) - (window.scrollX) + canvas_div.scrollLeft - 1 - absx + "px";
                        blockParent.style.top = (blockParent.getBoundingClientRect().top + window.scrollY) - (window.scrollY) + canvas_div.scrollTop - absy - 1 + "px";
                        arrowParent.style.left = (arrowParent.getBoundingClientRect().left + window.scrollX) - (window.scrollX) + canvas_div.scrollLeft - absx - 1 + "px";
                        arrowParent.style.top = (arrowParent.getBoundingClientRect().top + window.scrollY) + canvas_div.scrollTop - 1 - absy + "px";
                        canvas_div.appendChild(blockParent);
                        canvas_div.appendChild(arrowParent);
                        blockstemp[w].x = (blockParent.getBoundingClientRect().left + window.scrollX) + (parseInt(blockParent.offsetWidth) / 2) + canvas_div.scrollLeft - canvas_div.getBoundingClientRect().left - 1;
                        blockstemp[w].y = (blockParent.getBoundingClientRect().top + window.scrollY) + (parseInt(blockParent.offsetHeight) / 2) + canvas_div.scrollTop - canvas_div.getBoundingClientRect().top - 1;
                    }
                }
                blockstemp.filter(a => a.id == 0)[0].x = (drag.getBoundingClientRect().left + window.scrollX) + (parseInt(window.getComputedStyle(drag).width) / 2) + canvas_div.scrollLeft - canvas_div.getBoundingClientRect().left;
                blockstemp.filter(a => a.id == 0)[0].y = (drag.getBoundingClientRect().top + window.scrollY) + (parseInt(window.getComputedStyle(drag).height) / 2) + canvas_div.scrollTop - canvas_div.getBoundingClientRect().top;
                blocks = blocks.concat(blockstemp);
                blockstemp = [];
            }
        }
        
        function drawArrow(arrow, x, y, id) {
            if (x < 0) {
                canvas_div.innerHTML += '<div class="arrowblock"><input type="hidden" class="arrowid" value="' + drag.querySelector(".blockid").value + '"><svg preserveaspectratio="none" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M' + (blocks.filter(a => a.id == id)[0].x - arrow.x + 5) + ' 0L' + (blocks.filter(a => a.id == id)[0].x - arrow.x + 5) + ' ' + (paddingy / 2) + 'L5 ' + (paddingy / 2) + 'L5 ' + y + '" stroke="#C5CCD0" stroke-width="2px"/><path d="M0 ' + (y - 5) + 'H10L5 ' + y + 'L0 ' + (y - 5) + 'Z" fill="#C5CCD0"/></svg></div>';
                document.querySelector('.arrowid[value="' + drag.querySelector(".blockid").value + '"]').parentNode.style.left = (arrow.x - 5) - (absx + window.scrollX) + canvas_div.scrollLeft + canvas_div.getBoundingClientRect().left + "px";
            } else {
                canvas_div.innerHTML += '<div class="arrowblock"><input type="hidden" class="arrowid" value="' + drag.querySelector(".blockid").value + '"><svg preserveaspectratio="none" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 0L20 ' + (paddingy / 2) + 'L' + (x) + ' ' + (paddingy / 2) + 'L' + x + ' ' + y + '" stroke="#C5CCD0" stroke-width="2px"/><path d="M' + (x - 5) + ' ' + (y - 5) + 'H' + (x + 5) + 'L' + x + ' ' + y + 'L' + (x - 5) + ' ' + (y - 5) + 'Z" fill="#C5CCD0"/></svg></div>';
                document.querySelector('.arrowid[value="' + parseInt(drag.querySelector(".blockid").value) + '"]').parentNode.style.left = blocks.filter(a => a.id == id)[0].x - 20 - (absx + window.scrollX) + canvas_div.scrollLeft + canvas_div.getBoundingClientRect().left + "px";
            }
            document.querySelector('.arrowid[value="' + parseInt(drag.querySelector(".blockid").value) + '"]').parentNode.style.top = blocks.filter(a => a.id == id)[0].y + (blocks.filter(a => a.id == id)[0].height / 2) + canvas_div.getBoundingClientRect().top - absy + "px";
        }
        
        function updateArrow(arrow, x, y, children) {
            var arrowEl = document.querySelector('.arrowid[value="' + children.id + '"]');
            if (!arrowEl || !arrowEl.parentNode) {
                console.warn('[Flowy] Arrow element not found for children:', children.id);
                return;
            }
            var parentBlock = blocks.filter(id => id.id == children.parent)[0];
            if (!parentBlock) {
                console.warn('[Flowy] Parent block not found for children:', children.id);
                return;
            }
            
            if (x < 0) {
                arrowEl.parentNode.style.left = (arrow.x - 5) - (absx + window.scrollX) + canvas_div.getBoundingClientRect().left + "px";
                arrowEl.parentNode.innerHTML = '<input type="hidden" class="arrowid" value="' + children.id + '"><svg preserveaspectratio="none" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M' + (parentBlock.x - arrow.x + 5) + ' 0L' + (parentBlock.x - arrow.x + 5) + ' ' + (paddingy / 2) + 'L5 ' + (paddingy / 2) + 'L5 ' + y + '" stroke="#C5CCD0" stroke-width="2px"/><path d="M0 ' + (y - 5) + 'H10L5 ' + y + 'L0 ' + (y - 5) + 'Z" fill="#C5CCD0"/></svg>';
            } else {
                arrowEl.parentNode.style.left = parentBlock.x - 20 - (absx + window.scrollX) + canvas_div.getBoundingClientRect().left + "px";
                arrowEl.parentNode.innerHTML = '<input type="hidden" class="arrowid" value="' + children.id + '"><svg preserveaspectratio="none" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 0L20 ' + (paddingy / 2) + 'L' + (x) + ' ' + (paddingy / 2) + 'L' + x + ' ' + y + '" stroke="#C5CCD0" stroke-width="2px"/><path d="M' + (x - 5) + ' ' + (y - 5) + 'H' + (x + 5) + 'L' + x + ' ' + y + 'L' + (x - 5) + ' ' + (y - 5) + 'Z" fill="#C5CCD0"/></svg>';
            }
        }

        function snap(drag, i, blocko) {
            if (!rearrange) {
                canvas_div.appendChild(drag);
            }
            var totalwidth = 0;
            var totalremove = 0;
            var maxheight = 0;
            for (var w = 0; w < blocks.filter(id => id.parent == blocko[i]).length; w++) {
                var children = blocks.filter(id => id.parent == blocko[i])[w];
                if (children.childwidth > children.width) {
                    totalwidth += children.childwidth + paddingx;
                } else {
                    totalwidth += children.width + paddingx;
                }
            }
            totalwidth += parseInt(window.getComputedStyle(drag).width);
            var parentBlockForSnap = blocks.filter(a => a.id == blocko[i])[0];
            if (!parentBlockForSnap) {
                console.warn('[Flowy] Parent block not found in snap:', blocko[i]);
                return;
            }
            for (var w = 0; w < blocks.filter(id => id.parent == blocko[i]).length; w++) {
                var children = blocks.filter(id => id.parent == blocko[i])[w];
                var childBlockEl = document.querySelector(".blockid[value='" + children.id + "']");
                if (!childBlockEl || !childBlockEl.parentNode) {
                    console.warn('[Flowy] Child block element not found:', children.id);
                    continue;
                }
                if (children.childwidth > children.width) {
                    childBlockEl.parentNode.style.left = parentBlockForSnap.x - (totalwidth / 2) + totalremove + (children.childwidth / 2) - (children.width / 2) + "px";
                    children.x = parentBlockForSnap.x - (totalwidth / 2) + totalremove + (children.childwidth / 2);
                    totalremove += children.childwidth + paddingx;
                } else {
                    childBlockEl.parentNode.style.left = parentBlockForSnap.x - (totalwidth / 2) + totalremove + "px";
                    children.x = parentBlockForSnap.x - (totalwidth / 2) + totalremove + (children.width / 2);
                    totalremove += children.width + paddingx;
                }
            }
            drag.style.left = parentBlockForSnap.x - (totalwidth / 2) + totalremove - (window.scrollX + absx) + canvas_div.scrollLeft + canvas_div.getBoundingClientRect().left + "px";
            drag.style.top = parentBlockForSnap.y + (parentBlockForSnap.height / 2) + paddingy - (window.scrollY + absy) + canvas_div.getBoundingClientRect().top + "px";
            if (rearrange) {
                var dragBlockId = parseInt(drag.querySelector(".blockid").value);
                var dragTempBlock = blockstemp.filter(a => a.id == dragBlockId)[0];
                if (dragTempBlock) {
                    dragTempBlock.x = (drag.getBoundingClientRect().left + window.scrollX) + (parseInt(window.getComputedStyle(drag).width) / 2) + canvas_div.scrollLeft - canvas_div.getBoundingClientRect().left;
                    dragTempBlock.y = (drag.getBoundingClientRect().top + window.scrollY) + (parseInt(window.getComputedStyle(drag).height) / 2) + canvas_div.scrollTop - canvas_div.getBoundingClientRect().top;
                    dragTempBlock.parent = blocko[i];
                }
                for (var w = 0; w < blockstemp.length; w++) {
                    if (blockstemp[w].id != dragBlockId) {
                        const blockEl = document.querySelector(".blockid[value='" + blockstemp[w].id + "']");
                        const arrowEl = document.querySelector(".arrowid[value='" + blockstemp[w].id + "']");
                        if (!blockEl || !blockEl.parentNode || !arrowEl || !arrowEl.parentNode) {
                            console.warn('[Flowy] Block or arrow element not found in rearrange:', blockstemp[w].id);
                            continue;
                        }
                        const blockParent = blockEl.parentNode;
                        const arrowParent = arrowEl.parentNode;
                        blockParent.style.left = (blockParent.getBoundingClientRect().left + window.scrollX) - (window.scrollX + canvas_div.getBoundingClientRect().left) + canvas_div.scrollLeft + "px";
                        blockParent.style.top = (blockParent.getBoundingClientRect().top + window.scrollY) - (window.scrollY + canvas_div.getBoundingClientRect().top) + canvas_div.scrollTop + "px";
                        arrowParent.style.left = (arrowParent.getBoundingClientRect().left + window.scrollX) - (window.scrollX + canvas_div.getBoundingClientRect().left) + canvas_div.scrollLeft + 20 + "px";
                        arrowParent.style.top = (arrowParent.getBoundingClientRect().top + window.scrollY) - (window.scrollY + canvas_div.getBoundingClientRect().top) + canvas_div.scrollTop + "px";
                        canvas_div.appendChild(blockParent);
                        canvas_div.appendChild(arrowParent);

                        blockstemp[w].x = (blockParent.getBoundingClientRect().left + window.scrollX) + (parseInt(window.getComputedStyle(blockParent).width) / 2) + canvas_div.scrollLeft - canvas_div.getBoundingClientRect().left;
                        blockstemp[w].y = (blockParent.getBoundingClientRect().top + window.scrollY) + (parseInt(window.getComputedStyle(blockParent).height) / 2) + canvas_div.scrollTop - canvas_div.getBoundingClientRect().top;
                    }
                }
                blocks = blocks.concat(blockstemp);
                blockstemp = [];
            } else {
                blocks.push({
                    childwidth: 0,
                    parent: blocko[i],
                    id: parseInt(drag.querySelector(".blockid").value),
                    x: (drag.getBoundingClientRect().left + window.scrollX) + (parseInt(window.getComputedStyle(drag).width) / 2) + canvas_div.scrollLeft - canvas_div.getBoundingClientRect().left,
                    y: (drag.getBoundingClientRect().top + window.scrollY) + (parseInt(window.getComputedStyle(drag).height) / 2) + canvas_div.scrollTop - canvas_div.getBoundingClientRect().top,
                    width: parseInt(window.getComputedStyle(drag).width),
                    height: parseInt(window.getComputedStyle(drag).height)
                });
            }
            
            var arrowblock = blocks.filter(a => a.id == parseInt(drag.querySelector(".blockid").value))[0];
            var arrowx = arrowblock.x - blocks.filter(a => a.id == blocko[i])[0].x + 20;
            var arrowy = paddingy;
            drawArrow(arrowblock, arrowx, arrowy, blocko[i]);
            
            if (blocks.filter(a => a.id == blocko[i])[0].parent != -1) {
                var flag = false;
                var idval = blocko[i];
                while (!flag) {
                    if (blocks.filter(a => a.id == idval)[0].parent == -1) {
                        flag = true;
                    } else {
                        var zwidth = 0;
                        for (var w = 0; w < blocks.filter(id => id.parent == idval).length; w++) {
                            var children = blocks.filter(id => id.parent == idval)[w];
                            if (children.childwidth > children.width) {
                                if (w == blocks.filter(id => id.parent == idval).length - 1) {
                                    zwidth += children.childwidth;
                                } else {
                                    zwidth += children.childwidth + paddingx;
                                }
                            } else {
                                if (w == blocks.filter(id => id.parent == idval).length - 1) {
                                    zwidth += children.width;
                                } else {
                                    zwidth += children.width + paddingx;
                                }
                            }
                        }
                        blocks.filter(a => a.id == idval)[0].childwidth = zwidth;
                        idval = blocks.filter(a => a.id == idval)[0].parent;
                    }
                }
                blocks.filter(id => id.id == idval)[0].childwidth = totalwidth;
            }
            if (rearrange) {
                rearrange = false;
                cleanupDragStyling();
            }
            rearrangeMe();
            checkOffset();
        }

        function touchblock(event) {
            // Only reset dragblock on mousedown, not mouseup (we need to preserve it for click detection)
            if (event.type !== "mouseup" && event.type !== "touchend") {
                dragblock = false;
            }
            
            // Reset drag tracking only for new mousedown/touchstart interactions, not mousemove
            // BUT don't reset if we're currently in an active drag operation (active = true)
            if ((event.type === "mousedown" || event.type === "touchstart") && !active) {
                wasDragging = false;
            }
            
            if (hasParentClass(event.target, "block")) {
                var theblock = event.target.closest(".block");
                if (event.targetTouches) {
                    mouse_x = event.targetTouches[0].clientX;
                    mouse_y = event.targetTouches[0].clientY;
                } else {
                    mouse_x = event.clientX;
                    mouse_y = event.clientY;
                }
                if (event.type !== "mouseup" && hasParentClass(event.target, "block")) {
                    if (event.which != 3) {
                        if (!active && !rearrange) {
                            // Don't immediately start dragging - wait for mousemove to confirm it's a drag
                            dragblock = true;
                            drag = theblock;
                            dragx = mouse_x - (drag.getBoundingClientRect().left + window.scrollX);
                            dragy = mouse_y - (drag.getBoundingClientRect().top + window.scrollY);
                            
                            // Store mouse position for click vs drag detection
                            mouseDownPos = { x: mouse_x, y: mouse_y };
                        }
                    }
                } else if (event.type === "mouseup" && hasParentClass(event.target, "block")) {
                    // Handle block selection on mouseup (click)
                    
                    // If we're in an active drag operation, let endDrag handle it first
                    if (active || rearrange) {
                        // Use setTimeout to allow endDrag to complete first, then handle cleanup
                        setTimeout(function() {
                            // Re-check if this was actually a drag operation after endDrag completes
                            var wasActuallyDragging = wasDragging || justCompletedDrop;
                            
                            if (!wasActuallyDragging) {
                                // This was actually a click, handle it now
                                if (typeof window.handleBlockClick === 'function') {
                                    window.handleBlockClick(event, theblock);
                                }
                            }
                            
                            // Clean up flags
                            cleanupDragStyling(true);
                            justCompletedDrop = false;
                        }, 10); // Small delay to let endDrag complete
                        return;
                    }
                    
                    // Check if this was a drag operation BEFORE cleaning up
                    var wasActuallyDragging = wasDragging || justCompletedDrop;
                    
                    // Also check if this was just a mousedown without movement (a click)
                    var wasClick = dragblock && mouseDownPos && !wasDragging;
                    
                    // Always clean up drag styling on mouseup, but reset wasDragging only for block selection
                    cleanupDragStyling(true);
                    
                    // Reset the drop completion flag after processing
                    justCompletedDrop = false;
                    
                    // Handle block selection if this was a click (not a drag operation)
                    if (event.which != 3 && !rearrange && !wasActuallyDragging && wasClick) {
                        // This is a click on a block, not a drag operation
                        
                        // Call the block selection logic from WorkflowBuilder.vue
                        if (typeof window.handleBlockClick === 'function') {
                            window.handleBlockClick(event, theblock);
                        } else {
                            console.error('window.handleBlockClick function not found');
                        }
                    }
                }
            }
        }

        function hasParentClass(element, classname) {
            if (element.className) {
                if (element.className.split(' ').indexOf(classname) >= 0) return true;
            }
            return element.parentNode && hasParentClass(element.parentNode, classname);
        }

        flowy.moveBlock = function(event) {
            if (event.targetTouches) {
                mouse_x = event.targetTouches[0].clientX;
                mouse_y = event.targetTouches[0].clientY;
            } else {
                mouse_x = event.clientX;
                mouse_y = event.clientY;
            }
            
            // Check if we should start dragging based on mouse movement
            if (dragblock && mouseDownPos && !wasDragging) {
                var deltaX = Math.abs(mouse_x - mouseDownPos.x);
                var deltaY = Math.abs(mouse_y - mouseDownPos.y);
                var distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                
                if (distance > dragThreshold) {
                    wasDragging = true;
                    active = true;
                    
                    // Add drag styling now that we're actually dragging
                    if (drag) {
                        drag.classList.add("dragging-block", "being-dragged");
                        var canvas = document.getElementById("canvas");
                        if (canvas) {
                            canvas.classList.add("drag-active");
                        }
                    }
                }
            }
            
            // Only enter rearrangement logic if we're actually dragging (exceeded threshold)
            if (dragblock && wasDragging) {
                rearrange = true;
                if (drag && drag.classList) {
                    drag.classList.add("dragging", "dragging-block", "being-dragged");
                }
                
                // Add visual feedback for drop zones
                showDropZoneHints();
                
                var blockid = parseInt(drag.querySelector(".blockid").value);
                var currentBlock = blocks.filter(a => a.id == blockid)[0];
                if (!currentBlock) {
                    console.warn('Block not found in blocks array:', blockid);
                    return;
                }
                prevblock = currentBlock.parent;
                blockstemp.push(currentBlock);
                blocks = blocks.filter(function(e) {
                    return e.id != blockid
                });
                if (blockid != 0) {
                    var arrowEl = document.querySelector(".arrowid[value='" + blockid + "']");
                    if (arrowEl && arrowEl.parentNode) {
                        arrowEl.parentNode.remove();
                    }
                }
                var layer = blocks.filter(a => a.parent == blockid);
                var flag = false;
                var foundids = [];
                var allids = [];
                while (!flag) {
                    for (var i = 0; i < layer.length; i++) {
                        if (layer[i] != blockid) {
                            var layerBlock = blocks.filter(a => a.id == layer[i].id)[0];
                            if (layerBlock) {
                                blockstemp.push(layerBlock);
                            }
                            const blockEl = document.querySelector(".blockid[value='" + layer[i].id + "']");
                            const arrowEl = document.querySelector(".arrowid[value='" + layer[i].id + "']");
                            if (!blockEl || !arrowEl) {
                                console.warn('Block or arrow element not found for layer:', layer[i].id);
                                foundids.push(layer[i].id);
                                allids.push(layer[i].id);
                                continue;
                            }
                            const blockParent = blockEl.parentNode;
                            const arrowParent = arrowEl.parentNode;
                            if (!blockParent || !arrowParent) {
                                console.warn('Parent not found for block or arrow:', layer[i].id);
                                foundids.push(layer[i].id);
                                allids.push(layer[i].id);
                                continue;
                            }
                            blockParent.style.left = (blockParent.getBoundingClientRect().left + window.scrollX) - (drag.getBoundingClientRect().left + window.scrollX) + "px";
                            blockParent.style.top = (blockParent.getBoundingClientRect().top + window.scrollY) - (drag.getBoundingClientRect().top + window.scrollY) + "px";
                            arrowParent.style.left = (arrowParent.getBoundingClientRect().left + window.scrollX) - (drag.getBoundingClientRect().left + window.scrollX) + "px";
                            arrowParent.style.top = (arrowParent.getBoundingClientRect().top + window.scrollY) - (drag.getBoundingClientRect().top + window.scrollY) + "px";
                            drag.appendChild(blockParent);
                            drag.appendChild(arrowParent);
                            foundids.push(layer[i].id);
                            allids.push(layer[i].id);
                        }
                    }
                    if (foundids.length == 0) {
                        flag = true;
                    } else {
                        layer = blocks.filter(a => foundids.includes(a.parent));
                        foundids = [];
                    }
                }
                for (var i = 0; i < blocks.filter(a => a.parent == blockid).length; i++) {
                    var blocknumber = blocks.filter(a => a.parent == blockid)[i];
                    blocks = blocks.filter(function(e) {
                        return e.id != blocknumber
                    });
                }
                for (var i = 0; i < allids.length; i++) {
                    var blocknumber = allids[i];
                    blocks = blocks.filter(function(e) {
                        return e.id != blocknumber
                    });
                }
                if (blocks.length > 1) {
                    rearrangeMe();
                }
                dragblock = false;
            }
            if (active) {
                drag.style.left = mouse_x - dragx + "px";
                drag.style.top = mouse_y - dragy + "px";
            } else if (rearrange) {
                drag.style.left = mouse_x - dragx - (window.scrollX + absx) + canvas_div.scrollLeft + "px";
                drag.style.top = mouse_y - dragy - (window.scrollY + absy) + canvas_div.scrollTop + "px";
                blockstemp.filter(a => a.id == parseInt(drag.querySelector(".blockid").value)).x = (drag.getBoundingClientRect().left + window.scrollX) + (parseInt(window.getComputedStyle(drag).width) / 2) + canvas_div.scrollLeft;
                blockstemp.filter(a => a.id == parseInt(drag.querySelector(".blockid").value)).y = (drag.getBoundingClientRect().top + window.scrollY) + (parseInt(window.getComputedStyle(drag).height) / 2) + canvas_div.scrollTop;
            }
            if (active || rearrange) {
                if (mouse_x > canvas_div.getBoundingClientRect().width + canvas_div.getBoundingClientRect().left - 10 && mouse_x < canvas_div.getBoundingClientRect().width + canvas_div.getBoundingClientRect().left + 10) {
                    canvas_div.scrollLeft += 10;
                } else if (mouse_x < canvas_div.getBoundingClientRect().left + 10 && mouse_x > canvas_div.getBoundingClientRect().left - 10) {
                    canvas_div.scrollLeft -= 10;
                } else if (mouse_y > canvas_div.getBoundingClientRect().height + canvas_div.getBoundingClientRect().top - 10 && mouse_y < canvas_div.getBoundingClientRect().height + canvas_div.getBoundingClientRect().top + 10) {
                    canvas_div.scrollTop += 10;
                } else if (mouse_y < canvas_div.getBoundingClientRect().top + 10 && mouse_y > canvas_div.getBoundingClientRect().top - 10) {
                    canvas_div.scrollLeft -= 10;
                }
                var xpos = (drag.getBoundingClientRect().left + window.scrollX) + (parseInt(window.getComputedStyle(drag).width) / 2) + canvas_div.scrollLeft - canvas_div.getBoundingClientRect().left;
                var ypos = (drag.getBoundingClientRect().top + window.scrollY) + canvas_div.scrollTop - canvas_div.getBoundingClientRect().top;
                var blocko = blocks.map(a => a.id);
                for (var i = 0; i < blocks.length; i++) {
                    if (checkAttach(blocko[i])) {
                        const blockElement = document.querySelector(".blockid[value='" + blocko[i] + "']");
                        const indicatorElement = document.querySelector(".indicator");
                        
                        if (blockElement && blockElement.parentNode && indicatorElement) {
                            blockElement.parentNode.appendChild(indicatorElement);
                            indicatorElement.style.left = (blockElement.parentNode.offsetWidth / 2) - 5 + "px";
                            indicatorElement.style.top = blockElement.parentNode.offsetHeight + "px";
                            indicatorElement.classList.remove("invisible");
                        }
                        break;
                    } else if (i == blocks.length - 1) {
                        const indicatorElement = document.querySelector(".indicator");
                        if (indicatorElement && !indicatorElement.classList.contains("invisible")) {
                            indicatorElement.classList.add("invisible");
                        }
                    }
                }
            }
        }

        function checkOffset() {
            offsetleft = blocks.map(a => a.x);
            var widths = blocks.map(a => a.width);
            var mathmin = offsetleft.map(function(item, index) {
                return item - (widths[index] / 2);
            })
            offsetleft = Math.min.apply(Math, mathmin);
            if (offsetleft < (canvas_div.getBoundingClientRect().left + window.scrollX - absx)) {
                var blocko = blocks.map(a => a.id);
                for (var w = 0; w < blocks.length; w++) {
                    document.querySelector(".blockid[value='" + blocks.filter(a => a.id == blocko[w])[0].id + "']").parentNode.style.left = blocks.filter(a => a.id == blocko[w])[0].x - (blocks.filter(a => a.id == blocko[w])[0].width / 2) - offsetleft + canvas_div.getBoundingClientRect().left - absx + 20 + "px";
                    if (blocks.filter(a => a.id == blocko[w])[0].parent != -1) {
                        var arrowblock = blocks.filter(a => a.id == blocko[w])[0];
                        var arrowx = arrowblock.x - blocks.filter(a => a.id == blocks.filter(a => a.id == blocko[w])[0].parent)[0].x;
                        if (arrowx < 0) {
                            document.querySelector('.arrowid[value="' + blocko[w] + '"]').parentNode.style.left = (arrowblock.x - offsetleft + 20 - 5) + canvas_div.getBoundingClientRect().left - absx + "px";
                        } else {
                            document.querySelector('.arrowid[value="' + blocko[w] + '"]').parentNode.style.left = blocks.filter(id => id.id == blocks.filter(a => a.id == blocko[w])[0].parent)[0].x - 20 - offsetleft + canvas_div.getBoundingClientRect().left - absx + 20 + "px";
                        }
                    }
                }
                for (var w = 0; w < blocks.length; w++) {
                    blocks[w].x = (document.querySelector(".blockid[value='" + blocks[w].id + "']").parentNode.getBoundingClientRect().left + window.scrollX) + (canvas_div.scrollLeft) + (parseInt(window.getComputedStyle(document.querySelector(".blockid[value='" + blocks[w].id + "']").parentNode).width) / 2) - 20 - canvas_div.getBoundingClientRect().left;
                }
            }
        }

        function rearrangeMe() {
            var result = blocks.map(a => a.parent);
            for (var z = 0; z < result.length; z++) {
                if (result[z] == -1) {
                    z++;
                }
                var totalwidth = 0;
                var totalremove = 0;
                var maxheight = 0;
                for (var w = 0; w < blocks.filter(id => id.parent == result[z]).length; w++) {
                    var children = blocks.filter(id => id.parent == result[z])[w];
                    if (blocks.filter(id => id.parent == children.id).length == 0) {
                        children.childwidth = 0;
                    }
                    if (children.childwidth > children.width) {
                        if (w == blocks.filter(id => id.parent == result[z]).length - 1) {
                            totalwidth += children.childwidth;
                        } else {
                            totalwidth += children.childwidth + paddingx;
                        }
                    } else {
                        if (w == blocks.filter(id => id.parent == result[z]).length - 1) {
                            totalwidth += children.width;
                        } else {
                            totalwidth += children.width + paddingx;
                        }
                    }
                }
                if (result[z] != -1) {
                    blocks.filter(a => a.id == result[z])[0].childwidth = totalwidth;
                }
                for (var w = 0; w < blocks.filter(id => id.parent == result[z]).length; w++) {
                    var children = blocks.filter(id => id.parent == result[z])[w];
                    var r_blockEl = document.querySelector(".blockid[value='" + children.id + "']");
                    if (!r_blockEl || !r_blockEl.parentNode) {
                        console.warn('[Flowy] Block element not found in rearrangeMe:', children.id);
                        continue;
                    }
                    const r_block = r_blockEl.parentNode;
                    const r_array = blocks.filter(id => id.id == result[z]);
                    if (!r_array || r_array.length === 0) {
                        console.warn('[Flowy] Parent block not found in rearrangeMe:', result[z]);
                        continue;
                    }
                    r_block.style.top = r_array.y + paddingy + canvas_div.getBoundingClientRect().top - absy + "px";
                    r_array.y = r_array.y + paddingy;
                    if (children.childwidth > children.width) {
                        r_block.style.left = r_array[0].x - (totalwidth / 2) + totalremove + (children.childwidth / 2) - (children.width / 2) - (absx + window.scrollX) + canvas_div.getBoundingClientRect().left + "px";
                        children.x = r_array[0].x - (totalwidth / 2) + totalremove + (children.childwidth / 2);
                        totalremove += children.childwidth + paddingx;
                    } else {
                        r_block.style.left = r_array[0].x - (totalwidth / 2) + totalremove - (absx + window.scrollX) + canvas_div.getBoundingClientRect().left + "px";
                        children.x = r_array[0].x - (totalwidth / 2) + totalremove + (children.width / 2);
                        totalremove += children.width + paddingx;
                    }

                    var arrowblock = blocks.filter(a => a.id == children.id)[0];
                    var parentForArrow = blocks.filter(a => a.id == children.parent)[0];
                    if (!arrowblock || !parentForArrow) {
                        console.warn('[Flowy] Arrow or parent block not found:', children.id, children.parent);
                        continue;
                    }
                    var arrowx = arrowblock.x - parentForArrow.x + 20;
                    var arrowy = paddingy;
                    updateArrow(arrowblock, arrowx, arrowy, children);
                }
            }
        }
        
        document.addEventListener("mousedown", flowy.beginDrag);
        document.addEventListener("mousedown", touchblock, false);
        document.addEventListener("touchstart", flowy.beginDrag);
        document.addEventListener("touchstart", touchblock, false);
        

        document.addEventListener("mouseup", touchblock, false);
        document.addEventListener("mousemove", flowy.moveBlock, false);
        document.addEventListener("touchmove", flowy.moveBlock, false);

        document.addEventListener("mouseup", flowy.endDrag, false);
        document.addEventListener("touchend", flowy.endDrag, false);
    }

    function blockGrabbed(block) {
        grab(block);
    }

    function blockReleased() {
        release();
    }

    function blockSnap(drag, first, parent) {
        return snapping(drag, first, parent);
    }

    function beforeDelete(drag, parent) {
        return rearrange(drag, parent);
    }

    function addEventListenerMulti(type, listener, capture, selector) {
        var nodes = document.querySelectorAll(selector);
        for (var i = 0; i < nodes.length; i++) {
            nodes[i].addEventListener(type, listener, capture);
        }
    }

    function removeEventListenerMulti(type, listener, capture, selector) {
        var nodes = document.querySelectorAll(selector);
        for (var i = 0; i < nodes.length; i++) {
            nodes[i].removeEventListener(type, listener, capture);
        }
    }
    
    flowy.load();
}
